import { Link } from 'react-router-dom';

export function SubscriptionCancel() {
  return (
    <div className="sub-result">
      <div className="card sub-result-card">
        <div className="sub-result-icon" aria-hidden="true">&#x2139;&#xFE0F;</div>
        <h1>Subscription Not Completed</h1>
        <p>
          Your checkout was cancelled. No charges were made. You can try again whenever you&apos;re
          ready.
        </p>
        <div className="sub-result-actions">
          <Link to="/wallet" className="btn btn-primary">
            Return to Dashboard
          </Link>
          <Link to="/#pricing" className="btn btn-secondary">
            View Plans
          </Link>
        </div>
      </div>
    </div>
  );
}
